import { CloseOutlined } from '@ant-design/icons';
import { Button, Card, Stack } from 'shared';
import React from 'react';
import { SentryApiClient } from '_generated/api';
import { DatePicker } from 'antd';
import { SensorLabel } from './SensorLabel';
import moment from 'moment';
import dayjs from 'dayjs';

export type MomentRange = [moment.Moment | null, moment.Moment | null];

export interface SensorRangeCardProps {
  sensor?: SentryApiClient.SensorDTO;
  range?: MomentRange | null;
  onChange?: (range: MomentRange | null) => void;
}

export const SensorRangeCard: React.FC<SensorRangeCardProps> = ({
  sensor,
  range,
  onChange,
}) => {
  return (
    <Card
      title={
        <Stack alignment="middle" gap="apart">
          <SensorLabel sensor={sensor} />
        </Stack>
      }
    >
      <DatePicker.RangePicker
        showTime
        format="YYYY-MM-DD HH:mm"
        value={
          range
            ? [
                range[0] ? dayjs(range[0].toDate()) : null,
                range[1] ? dayjs(range[1].toDate()) : null,
              ]
            : null
        }
        onChange={(values) =>
          onChange &&
          onChange(
            values
              ? [
                  values[0] ? moment(values[0].toDate()) : null,
                  values[1] ? moment(values[1].toDate()) : null,
                ]
              : null
          )
        }
      />
    </Card>
  );
};
